import { Avatar, styled } from '@mui/material';
import { Colors } from 'library';

export const WorkerAvatar = styled(Avatar)(({ width, height }: { width?: number; height?: number }) => ({
    color: Colors.white,
    backgroundColor: Colors.darkNavy,
    width: width || 100,
    height: height || 100,
    borderRadius: '50%',
    marginTop: 10,
    display: 'inline-flex',
}));
